import React, { Fragment } from 'react';
import styles from './styles.scss';

import { Button, Dialogger, Toaster } from '@densityco/ui';
import { SenseiApi } from '../../../../utils/api';
import { Sensor } from '../../../../types/api';
import { useRequiredSessionToken } from '../../../../utils/session-token';
import { commaSeparateList } from '../../../../utils/comma-separate';

type StopDataCaptureButtonProps = {
  sensors: Array<{serial_number: Sensor['serial_number']}>;
};

const StopDataCaptureButton: React.FunctionComponent<StopDataCaptureButtonProps> = props => {
  const { sensors } = props;
  const accessToken = useRequiredSessionToken();

  const onStopDataCapture = () => {
    const serialNumberList = commaSeparateList(sensors.map(i => i.serial_number));

    return Dialogger.confirm({
      title: 'Stop captures',
      prompt: (
        <p className={styles.text}>
          Would you like to stop any captures currently in progress at{' '}
          {serialNumberList}?
        </p>
      ),
      confirmText: 'Stop capturing data',
    }).then(ok => {
      if (!ok) {
        return;
      }

      SenseiApi.stopCapture(accessToken, sensors.map(i => i.serial_number)).then(() => {
        Toaster.showToast({
          text: `Data capture stop command sent to ${sensors.length} sensors.`,
        });
      }).catch(() => {
        Toaster.showToast({ type: 'error', text: `Error stopping data capture!` });
      })
    });
  };

  return (
    <Button disabled={sensors.length === 0} onClick={onStopDataCapture}>
      Stop Data Capture
    </Button>
  );
};

export default StopDataCaptureButton;
